import React, { useState } from "react";
import "./TestPerformance.css";
import SubjectWiseAnalysis from "../analysis/subjectwise/SubjectWiseAnalysis";
import images from "../../../utilities/images/images";

const TestPerformance = ({ latestTest }) => {
  const [showSubjectWise, setShowSubjectWise] = useState(false);

  if (!latestTest) return null;

  const summary = latestTest.student_summary;

  const testDate = new Date(summary.to_be_held_on);
  const formattedDate = testDate.toLocaleDateString("en-GB");

  return (
    <div className="ltp-wrapper">
      <h3 className="ltp-title">Latest Test Performance</h3>

      <div className="ltp-container">

        <div className="ltp-top-row">
          <div>
            <p className="test-info">
              <span className="test-label">Test ID:</span> {summary.paper_id}
            </p>
            <p className="test-info">
              <span className="test-label">Test Type:</span> {latestTest.test_name || "Class Test"}
            </p>
          </div>

          <div className="ltp-right">
            <p className="ltp-small-text">
              <span className="ltp-bold">Conducted on:</span> {formattedDate}
            </p>

            <p className="ltp-view-text" onClick={() => setShowSubjectWise(!showSubjectWise)}>
              {showSubjectWise ? "Close" : "View Performance"}
               <img
               src={
                showSubjectWise
               ? images.upangle_icon 
                 : images.downangle_icon   
                 }
                   alt="icon"
                 className="ltp-view-icon"
                  />
            </p>
          </div>
        </div>

        {/* ---- Stats Boxes ---- */}
        <div className="ltp-stats-row">
          <div className="ltp-box">
  <div className="ltp-label-row">
    <p className="ltp-label">Overall Marks</p>
    <img src={images.overall_icon} alt="Marks Icon" className="ltp-icon" />
  </div>

  <h4 className="ltp-value">
    {summary.self_score}/{summary.total_marks}
  </h4>
</div>

                  <div className="ltp-box">
  <div className="ltp-label-row">
    <p className="ltp-label">Class Rank</p>
    <img src={images.rank_icon} alt="Marks Icon" className="ltp-icon" />
  </div>

  <h4 className="ltp-value">
    {summary.rank}
  </h4>
</div>
                <div className="ltp-box">
  <div className="ltp-label-row">
    <p className="ltp-label">percentage</p>
    <img src={images.percent_icon} alt="Marks Icon" className="ltp-icon" />
  </div>

  <h4 className="ltp-value">
    {summary.percentage}
  </h4>
</div>
<div className="ltp-box">
  <div className="ltp-label-row">
    <p className="ltp-label">percentile</p>
    <img src={images.percentile_icon} alt="Marks Icon" className="ltp-icon" />
  </div>

  <h4 className="ltp-value">
    {summary.percentile}
  </h4>
</div>

        </div>
        
      {showSubjectWise && (
  <SubjectWiseAnalysis subjects={latestTest?.student_summary?.subject_list || []} />
)}
      </div>

    </div>
  );
};

export default TestPerformance;
